module.exports = __webpack_public_path__ + "img/line3.2addf14f.png";